import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../context/LangContext";
import { translations } from "./translation";
import { useTheme } from "../context/ThemeContext";

export default function HeroText() {
  const { scrollY } = useScroll();

  const y = useTransform(scrollY, [0, 400], [0, 80]);
  const opacity = useTransform(scrollY, [0, 300], [1, 0.7]);

  const scrollToAbout = () => {
    const el = document.getElementById("about");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const { lang } = useLang();
  const t = translations[lang];
  const { theme } = useTheme();

  return (
    <motion.div style={{ y, opacity }}>
      {/* 🔥 TITLE */}
      <motion.h1
        initial="hidden"
        animate="visible"
        variants={{
          hidden: {},
          visible: {
            transition: { staggerChildren: 0.03 },
          },
        }}
        style={{
          fontSize: "clamp(15px, 2vw, 52px)",
          fontWeight: 700,
          lineHeight: 1.1,
          marginBottom: "20px",
          color: "white", // ✅ важно
        }}
      >
        {t.heroTitle.split(":").map((part, index) => (
          <div key={index}>
            {part.split("").map((char, i) => (
              <motion.span
                key={i}
                variants={{
                  hidden: { opacity: 0, y: 30 },
                  visible: { opacity: 1, y: 0 },
                }}
              >
                {char}
              </motion.span>
            ))}

            {/* 🔥 перенос строки */}
            {index === 0 && <br />}
          </div>
        ))}
      </motion.h1>

      {/* SUBTITLE */}
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        style={{
          fontSize: "clamp(16px, 4vw, 20px)",
          color: "white", // ✅ было #ccc
          marginBottom: "10px",
        }}
      >
        {t.heroSubtitle}
      </motion.p>

      {/* DESCRIPTION */}
      <motion.p
        style={{
          fontSize: "clamp(14px, 2.2vw, 18px)",
          maxWidth: "600px",
          margin: "0 auto 30px",
          color: theme.secondaryText, // ✅ было #aaa
        }}
      >
        {t.heroDesc}
      </motion.p>

      {/* BUTTON */}
      <motion.button
        onClick={scrollToAbout}
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.9 }}
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.97 }}
        style={{
          background: "#1976d2", // ✅ MUI blue
          padding: "14px 28px",
          borderRadius: "8px", // ✅ меньше скругление как MUI
          color: "#fff",
          border: "none",
          fontWeight: 600,
          cursor: "pointer",
          fontSize: "clamp(14px, 2vw, 16px)",

          // 🎯 MUI shadow (главное отличие)
          boxShadow:
            "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",

          transition: "all 0.2s ease",
        }}
        // whileHover={{
        //   background: "#1565c0", // 🔥 hover как MUI
        //   boxShadow:
        //     "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
        // }}
      >
        {t.aboutBtn}
      </motion.button>
    </motion.div>
  );
}
